import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, RoutesRecognized } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from './shared/services/shared.service';
import { GlobalService } from './shared/services/global.service';
import { environment } from '../environments/environment';
import { HTML2TXTPipe } from './shared/pipe/common.pipe';
import { filter, startWith, pairwise, retry, throwError, timer } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
    private env: any = environment;
    private urlPath: any;
    public routeParams: any;

    private toRoute: any;
    private toRoute1: any;
    private toRouteParams: any;
    private fromRoute1: any;
    private isSavedAnswer: any;
    private allStats1: any = [];
    private readonly childData: any = ['One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight'];
    private queryParamsOBJ: any = {};
    private eventObj = {};
    private subscribeObj: any;
    private splitUrlPath: any;

    constructor(public sharedService: SharedService,
        private readonly globalService: GlobalService,
        public HTML2TXT: HTML2TXTPipe,
        public translate: TranslateService,
        private readonly router: Router) {
        translate.addLangs(['ar', 'cs', 'de', 'en', 'es', 'fr', 'it', 'ja', 'nl', 'pl', 'pt', 'ru', 'sv', 'th', 'tr', 'zh']);
        translate.setDefaultLang('en');
        let $that = this;
        console.info('App Component Loaded.....');

        this.urlPath = globalThis.location.href;
        this.splitUrlPath = (this.urlPath).split('?');

        if (!this.splitUrlPath?.length) {
            console.error(`[AppComponent] access_denied - splitUrlPath is not available in the query string`);
            $that.router.navigate(['/access_denied']);
            return;
        }

        if (!!this.splitUrlPath[1] && this.splitUrlPath[1] === 'null') {
            console.error(`[AppComponent] access_denied - splitUrlPath[1] is null in the query string`);
            $that.router.navigate(['/access_denied']);
            return;
        }

        this.routeParams = new URLSearchParams(this.splitUrlPath[1]);

        if(this.urlPath.includes('consent-page')){
            const objData:any = {};
            if(this.splitUrlPath[1]){
                this.splitUrlPath[1].split('&').forEach((key:any)=>{
                    const data = key.split("=");
                    if(data.length){
                        objData[data[0]] = data[1] || '';
                    }
                });
            }
            $that.router.navigate(['/consent-page'], { queryParams: {...objData}});
            return;
        }

        if(this.urlPath.includes('security-check')){
            const objData:any = {};
            this.splitUrlPath[1].split('&').forEach((key:any)=>{
                const data = key.split("=");
                if(data.length){
                    try {
                        objData[data[0]] = decodeURIComponent(data[1] || '');
                    } catch (e) {
                        objData[data[0]] = data[1] || '';
                    }
                }
            });
            if(this.urlPath.includes('security-check-all')){
                $that.router.navigate(['/security-check-all'], { queryParams:{...objData}});
                return;
            }
            $that.router.navigate(['/security-check'], { queryParams:{...objData}});
            return;
        }

        if(this.urlPath.includes('survey-satisfaction')){
            const objData:any = {};
            this.splitUrlPath[1].split('&').forEach((key:any)=>{
                const data = key.split("=");
                if(data.length){
                    objData[data[0]] = data[1] || '';
                }
            });
            $that.router.navigate(['/survey-satisfaction'], { queryParams:{...objData}});
            return;
        }

        if (this.urlPath.includes('access_denied') || globalThis.location.pathname.includes('access_denied')) {
            return;
        }

        if (this.routeParams.get('langCode')) {
            let langCode = this.routeParams.get('langCode').toLowerCase();
            if(langCode && !['ar', 'cs', 'de', 'en', 'es', 'fr', 'it', 'ja', 'nl', 'pl', 'pt', 'ru', 'sv', 'th', 'tr', 'zh'].includes(langCode)){
                langCode = 'en';
            }
            this.translate.use(langCode);
        }

        if (!!this.routeParams.get('survNum') && this.routeParams.get('survNum') === 'null'
            && !!this.routeParams.get('uid') && this.routeParams.get('uid') === 'null') {
            console.error(`[AppComponent] access_denied - survNum and uid are null in the query string`);
            $that.router.navigate(['/access_denied']);
            return;
        }

        const objData:any = {};
        if(this.splitUrlPath?.length
            && this.splitUrlPath[1]){
            this.splitUrlPath[1].split('&').forEach((key:any)=>{
                const data = key.split("=");
                if(data.length){
                    objData[data[0]] = data[1] || '';
                }
            });
            this.globalService.getQueryParamsAndSaveToVariable({...objData});
        }


        this.sharedService.rootData = {
            piiQuesFormDetails : {}, //having  pii form details entered by user
            smsQuesFormDetails : {},
            sentAdrsValidOnUSPS : 0, //how much time form will sent on USPS for Address validation
            invalidPIIQusKey : {},
            pcId : this.env.innovate.pointClubSupId,
            piiCatId : this.env.innovate.piiCategoryId,
            dobRHQId : this.env.innovate.dobRedHerringQId,
            bbCenterExpectedDateQue : this.env.innovate.bbCenterExpectedDueDateQueId,
            bbCenterChildInfoQueId : this.env.innovate.bbCenterChildInfoQueId,
            babyCenterProfileSurveyJobId : this.env.innovate.babyCenterProfileSurveyJobId,
            wteProfileSurveyJobId : this.env.innovate.wteProfileSurveyJobId,
            profilingJobs : this.env.innovate.profilingJobs,
            trimsterQuestionsDetails : [],
            trimsterAns : '',
            trimsterWeekAns : '',
            bbCenterChildDetails : [],
            piiQuesKey : [],
            originalTermURL : '',



            isRAIDobZipAdded : this.routeParams.get('RAIJuris'), //Saved in group collection if DOB+Zip file uoloaded.

            showConfirmMesg : false, //If PII form value populated then we will show confirm message to the user
            //@ADMIN-2632 Contain selected either Age or zip code value(depand on ques seq) and used to check these value in RAI_AGE_Zip collection.
            //If Age asked first(vice versa),  when zipcode ask we will check both answer in collection if they matched user will continue else terminate
            selectedDobZipRAI : {},
            isPIIOPTAdded : false,
            babyCenterExpectedDueDate : false,
            isAgeOfChildAdded : false,
            bbCenterChildInfoQueDetails : [],
            isPCProfile : this.routeParams.get('isPCProfile'),
            smsVerified : this.routeParams.get('isMobileVerified'),
            oeQues : this.routeParams.get('oeQuestionIds'),
            taQues : this.routeParams.get('taQuestionIds'),
            geoQuestionsKeyDetails : [],
            zipMasterData : {},
            verifyMobNumSMS : false,
            validToVerifySMS : true,
            smsVerifyCount : 0,
            termReason : '',
            countryCode : (!!$that.routeParams.get('cntryCode') && $that.routeParams.get('cntryCode') !== 'null')
                            ? $that.routeParams.get('cntryCode')
                            : 'US',
            PID : (!!$that.routeParams.get('PID') && $that.routeParams.get('PID') !== 'null')   // memeber id or PID
                    ? $that.routeParams.get('PID')
                    : '',
            supCode : (!!$that.routeParams.get('supCode') && $that.routeParams.get('supCode') !== 'null')
                        ? $that.routeParams.get('supCode')
                        : 'FEsupplier',
            supId : $that.routeParams.get('supId'),  // used during pixel trigger
            surveyFlowLogic : true,
        }

        let uid: any = 'Test';
        if (!!$that.routeParams.get('uid') && $that.routeParams.get('uid') !== 'null') {
            // actual survey
            uid = $that.routeParams.get('uid');
        }
        this.sharedService.rootData.uid = uid;
        const payload:any = {
            encSurveyNumber : $that.routeParams.get('survNum'),
            supCode: this.sharedService.rootData.supCode,
            uid
        };
        if (!$that.routeParams.get('survNum') || $that.routeParams.get('survNum') === 'null') {
            const params = new URLSearchParams(globalThis.location.search);
            console.error(`[AppComponent] access_denied - survNum missing from query string ${JSON.stringify(this.sharedService.rootData)} `);
        }
        if(this.env.app === 'innovateBackendApp-Staging'){
            console.log('getSurveyDetails payload ======> ', JSON.stringify(payload));
        }
        $that.sharedService.getSurveyDetails(payload)
            .pipe(
                retry({
                    count: 1,
                    delay: (err: any) => {
                        if (err?.status !== 200) {
                            console.error(`getSurveyDetails retrying after status 0 ======> ${JSON.stringify(err)} ${$that.urlPath} ${JSON.stringify($that.sharedService.rootData)}`);
                            return timer(500);
                        }
                        return throwError(() => err);
                    }
                })
            )
            .subscribe({
            next(respObj:any){

                if(respObj.status !== 'Success' || !respObj.data){
                    console.error(`[AppComponent] access_denied - getSurveyDetails failed - status not Success or data not available`);
                    $that.router.navigate(['/access_denied']);
                    return;
                }
                respObj.data = $that.sharedService.commonDecryptionMethod(respObj.data);
                if(!respObj.data.groupDetail){
                    console.error(`[AppComponent] access_denied - getSurveyDetails failed - groupDetail not found`);
                    $that.router.navigate(['/access_denied']);
                    return;
                }
                if (respObj.data.decryptedToken) {
                    // decrypted token for only actual survey, for test survey it will be undefined
                    $that.sharedService.rootData.token = respObj.data.decryptedToken;
                }
                $that.setNewRelicUserIdFromSurveyToken($that.sharedService.rootData.token);
                $that.sharedService.rootData.grp_id = Number.parseInt(respObj.data.decryptedSurveyNum);
                $that.sharedService.rootData.currentGrpId = $that.sharedService.rootData.grp_id;
                $that.sharedService.rootData.group = respObj.data.groupDetail;
                $that.sharedService.rootData.isPega = respObj.data.groupDetail.isPega;
                $that.sharedService.rootData.mid = respObj.data.mid;
                $that.sharedService.rootData.jb_id = respObj.data.jobDetail.id;
                $that.sharedService.rootData.jobDetailsObj = respObj.data.jobDetail;
                $that.sharedService.rootData.supplierDetail = respObj.data.supplierDetail;
                $that.sharedService.rootData.roundTableTrackingEnabled = respObj.data.roundTableTrackingEnabled;

                $that.sharedService.rootData.oeThreshLev = respObj.data?.taLevel || respObj.data?.jobDetail?.oeThreshLev;

                $that.sharedService.rootData.isOEValidation = !respObj.data.jobDetail.chkOeValid
                                                                ? 0
                                                                : ((respObj.data?.dsblTA)
                                                                    ? 0
                                                                    : 1);

                // group language
                $that.sharedService.rootData.langCode = (!!$that.routeParams.get('langCode') && $that.routeParams.get('langCode') !== 'null')
                ? $that.routeParams.get('langCode')
                : '';

                // $that key will be used in saving answers of question in the context of PID and group Id
                $that.sharedService.rootData.keyForSaving = $that.sharedService.rootData.grp_id + '_' + $that.sharedService.rootData.supCode + '_' + $that.sharedService.rootData.PID;

                //For pc case AGE question never asked and get calculated value to check DOB
                if (!!$that.routeParams.get('AGE') && !isNaN(Number.parseInt($that.routeParams.get('AGE')))) {
                    $that.sharedService.rootData.trgAgeQuesAns = $that.routeParams.get('AGE');
                    //In case of pointclub ZIPCODES question asked(Not expired) and Age_jurisdiction file uploaded
                    //At that time we will matched both question with that file
                    $that.sharedService.rootData.selectedDobZipRAI["age"] = $that.routeParams.get('AGE');
                }

                // $that.routeParams.get('Test')
                $that.sharedService.rootData.Test = respObj.data.isDecryptedTokenTest;
                if ($that.sharedService.rootData.Test) {
                    // for test survey adding Test in the end of key so actual and test survey will be different
                    $that.sharedService.rootData.keyForSaving += '_Test';
                }

                // $that.routeParams.get('existIds'] - are those id's which already gone through from survey using querystring
                if (!!$that.routeParams.get('existIds') && $that.routeParams.get('existIds') !== 'null') {
                    payload['existIds'] = $that.routeParams.get('existIds');
                }
                if($that.sharedService.rootData.smsVerified){
                    payload['isMobVerified'] = $that.sharedService.rootData.smsVerified
                }
                if($that.routeParams.get('oeQuestionIds')){
                    payload['oeQuestionIds'] = $that.routeParams.get('oeQuestionIds')
                }

                if($that.routeParams.get('taQuestionIds')){
                    payload['taQuestionIds'] = $that.routeParams.get('taQuestionIds')
                }               
                $that.sharedService.getSurveyTargetDetails(payload)
                    .pipe(
                        retry({
                            count: 1,
                            delay: (err: any) => {
                                if (err?.status !== 200) {
                                    console.error(`getSurveyTargetDetails retrying after status 0 ======> ${JSON.stringify(err)} ${JSON.stringify($that.sharedService.rootData)} ${JSON.stringify(payload)}`);
                                    return timer(500);
                                }
                                return throwError(() => err);
                            }
                        })
                    )
                    .subscribe({
                    next(respDetails: any) {

                        respDetails.data = $that.sharedService.commonDecryptionMethod(respDetails.data);
                        $that.sharedService.rootData.grpTrgtQuestions = respDetails.data['grpTrgtQuestions'];
                        $that.sharedService.rootData.ZipTrgQues = respDetails.data['ZipTrgQues'];

                        $that.sharedService.rootData.redirectToGroup = respDetails.data['redirectToGroup'] || null;
                        $that.sharedService.rootData.piiQuesKey = respDetails.data['piiQuesKey'];
                        $that.sharedService.rootData.isPIIOPTAdded = respDetails.data['isPIIOPTAdded'];

                        $that.sharedService.rootData.questions = respDetails.data['questions'];
                        $that.sharedService.rootData.babyCenterExpectedDueDate = respDetails.data['babyCenterExpectedDueDate'];
                        $that.sharedService.rootData.trimsterQuestionsDetails = respDetails.data['trimsterQuestionsDetails'];
                        $that.sharedService.rootData.geoQuestionsKeyDetails = respDetails.data['geoQuestionsKeyDetails'];
                        $that.sharedService.rootData.targets = respDetails.data['grpTargets'];
                        if($that.sharedService.rootData.questions?.length){
                            const urlPath = $that.splitUrlPath[0].split('/');
                            const ind = $that.sharedService.rootData.questions.findIndex((que:any)=> que.questionKey.toLowerCase() === urlPath[urlPath.length - 1].toLowerCase());
                            //If we are on last question no need to change index of question
                            if(ind !== -1){
                                const frstVal = JSON.parse(JSON.stringify($that.sharedService.rootData.questions[ind]));
                                $that.sharedService.rootData.questions.splice(ind,1);
                                $that.sharedService.rootData.questions.unshift(frstVal);
                            }
                        }
                        $that.sharedService.updateRootDataQuestions($that.sharedService.rootData.questions);

                        if (Object.keys($that.eventObj).length) {
                            $that.checkRouter($that.eventObj);
                        }

                        if (!respDetails.data['questions'] || !Object.keys(respDetails.data['questions']).length) {
                            $that.sharedService.rootData.viewLoading = false;
                            const urlPath = $that.splitUrlPath[0].split('/');
                            if (urlPath[urlPath.length - 1] !== 'final') {
                                $that.router.navigate(['/survey/final'], { queryParams: $that.routeParams });
                            }
                            return;
                        }
                    },
                    error(err: any) {
                        console.error(`getSurveyTargetDetails error access_denied ======> ${JSON.stringify(err)} ${JSON.stringify($that.sharedService.rootData)} ${JSON.stringify(payload)}`);
                        $that.router.navigate(['/access_denied']);
                        return;
                    }
                    });
            },
            error(err: any) {
                console.error(`getSurveyDetails error access_denied ======> ${JSON.stringify(err)} ${JSON.stringify($that.sharedService.rootData)}`);
                $that.router.navigate(['/access_denied']);
                return;
            }
            });

        this.subscribeObj = this.router.events
            .pipe(filter((evt: any) => evt instanceof RoutesRecognized), startWith(null), pairwise())
            .subscribe((events: [RoutesRecognized | null, RoutesRecognized | null]) => {
                $that.eventObj = events;
                this.sharedService.rootData.viewLoading = true;
                //##### Set Timeout Because Below(Router Change) Functionality Execute before Above Function (Amarish)
                if ((this.sharedService.rootData.token && !this.sharedService.rootData.Test) || this.sharedService.rootData.Test) {
                    $that.checkRouter(events);
                }
                // }, 2000);
            })
    }

    ngOnInit() {
    }

    ngOnDestroy(): void {
        this.subscribeObj.unsubscribe();
    }

    /** Correlates Browser sessions/errors with this respondent when the NR agent is loaded. */
    private setNewRelicUserIdFromSurveyToken(token: string | undefined): void {
        if (!token) {
            return;
        }
        (window as any).newrelic?.setUserId?.(token);
    }

    switchLang(lang: string) {
    }

    private checkRouter(events: any) {
        const $that = this;
        // setTimeout(() => {

        const previousUrlOBJ = events[0];
        const currentUrlOBJ = events[1];

        $that.toRouteParams = currentUrlOBJ.state.root.children?.length
            ? currentUrlOBJ.state.root.children[0].params['questionType']
            : '';

        const splitUrlPathPrevious = previousUrlOBJ ? (previousUrlOBJ.url).split('?') : [];
        if (splitUrlPathPrevious?.length) {
            if (splitUrlPathPrevious[0]?.length) {
                let subSplitUrlPathPrevious: any = splitUrlPathPrevious[0].split('/');
                $that.fromRoute1 = (!!subSplitUrlPathPrevious[2] && subSplitUrlPathPrevious[2] !== 'null')
                    ? subSplitUrlPathPrevious[2]
                    : null;
            }
        }

        const splitUrlPathCurrent = (currentUrlOBJ.url).split('?');
        if (splitUrlPathCurrent?.length) {
            if (splitUrlPathCurrent[0]?.length) {
                let subSplitUrlPathCurrent: any = splitUrlPathCurrent[0].split('/');
                $that.toRoute = !!subSplitUrlPathCurrent[1] && subSplitUrlPathCurrent[1] !== 'null'
                    ? subSplitUrlPathCurrent[1]
                    : null;
                $that.toRoute1 = (!!subSplitUrlPathCurrent[2] && subSplitUrlPathCurrent[2] !== 'null')
                    ? subSplitUrlPathCurrent[2]
                    : null;
            }
        }

        $that.queryParamsOBJ = currentUrlOBJ.state.root.queryParams;

        let currentState: any;

        if ($that.toRoute1 === 'final'
            || $that.toRoute1 === 'closed'
            || $that.toRoute1 === 'pii'
            || $that.toRoute1 === 'sms_verification') {
            currentState = $that.toRoute1;
        } else {
            // age // #1039 - dash key in question Key
            currentState = !!$that.toRouteParams && $that.toRouteParams != 'null'
                ? this.HTML2TXT.transform(($that.toRouteParams).toLowerCase())
                : '';
        }

        //show current state form , currentState is form-id in surveyProcess.html
        this.sharedService.rootData.currentState = currentState;

        if ((this.toRoute === null || !this.toRoute.includes('survey')) && this.toRoute !== 'access_denied') {
            console.error(`[AppComponent] access_denied - toRoute is not available in the query string`);
            this.router.navigate(['/access_denied']);
        } else if (this.toRoute === 'access_denied' || (this.toRoute === 'survey' && this.toRoute1 === 'closed')) {
            this.sharedService.rootData.viewLoading = false;
        } else {
            const localStorageSavedAnswers: any = this.sharedService.getLocalStorage('localStorageSavedAnswers');
            //Check in localStorage all questions answer is saved or not
            $that.isSavedAnswer = (localStorageSavedAnswers?.length
                && localStorageSavedAnswers[0][$that.sharedService.rootData.keyForSaving])
                ? localStorageSavedAnswers[0][$that.sharedService.rootData.keyForSaving]
                : null;

            const fromState = ($that.fromRoute1) ? $that.fromRoute1.toUpperCase() : '';

            //setTimeout(() => {

            if (this.sharedService.rootData.token && !this.sharedService.rootData.Test) {
                this.sharedService.getTransaction(this.sharedService.rootData.uid)
                    .pipe(
                        retry({
                            count: 1,
                            delay: (err: any) => {
                                if (err?.status !== 200) {
                                    console.error(`[AppComponent] getTransaction retrying after status 0 ${JSON.stringify(err)} ${JSON.stringify($that.sharedService.rootData)}`);
                                    return timer(500);
                                }
                                return throwError(() => err);
                            }
                        })
                    )
                    .subscribe({
                        next(trans: any) {
                            trans.data = $that.sharedService.commonDecryptionMethod(trans.data);
                            if (!!trans && trans != 'null' && trans.data) {
                                $that.sharedService.rootData.mbr_id = trans.data.mbr_id; // get PID from database
                                $that.sharedService.rootData.jb_id = trans.data.jb_id; // get job id form db
                                $that.sharedService.rootData.isDashboard = trans.data.isDashboard; // get isDashboard
                                $that.sharedService.rootData.originalTermTrans = trans.data.st;
                                $that.sharedService.rootData.originalTerm = trans.data.st == environment.innovate.transactionStatus['PST'] || trans.data.st == environment.innovate.transactionStatus['PSQT'] || trans.data.st == environment.innovate.transactionStatus['PSOQ'];
                                if ($that.sharedService.rootData.originalTerm && !$that.sharedService.rootData.originalTermURL) {
                                    $that.sharedService.getSupplierRedirectURL($that.sharedService.rootData.uid)
                                        .subscribe({
                                            next(data: any) {
                                                $that.sharedService.rootData.originalTermURL = $that.env.innovate.oldRouteEnable
                                                    ? data.url
                                                    : data.data;
                                            },
                                            error(err: any) {
                                                console.error(`[AppComponent] getSupplierRedirectURL error:${JSON.stringify(err)} ${JSON.stringify($that.sharedService.rootData)}`);
                                            }
                                        });
                                }

                                if (trans.data.hasOwnProperty("RIDResp"))
                                    $that.sharedService.rootData.RVID = trans.data.RIDResp.RVid;

                                // now we are checking that PID and supCode of query string AND db, if not than access denied
                                // FESupCode match in case of include/exclude csv supcode survey
                                if (($that.sharedService.rootData.PID?.toString() == $that.sharedService.rootData.mbr_id?.toString()) &&
                                    (trans.data.supCode?.toString() == $that.sharedService.rootData.supCode?.toString()) ||
                                    (trans.data.FESupCode?.toString() == $that.sharedService.rootData.supCode?.toString())) {

                                    let isCmplt = trans.data.isCmp;
                                    if (!$that.sharedService.rootData.surveyFlowLogic && isCmplt) {
                                        $that.router.navigate(['/survey/closed'], { queryParams: { message: 2, ...$that.queryParamsOBJ } });

                                    } else {
                                        // it is the case of accessible stat
                                        // localStorageService.clearAll();
                                        $that.sharedService.rootData.demographic = {}; // this is used for sungle punch, numeric and text field in form model
                                        $that.sharedService.rootData.multipunch = {}; // this is used for multipunch in form model
                                        $that.sharedService.doMultiPunchCheckbox($that.sharedService.rootData.multipunch);
                                        let piiQuesFormDetails, smsQuesFormDetails;

                                        let stateName = (!!currentState && currentState != 'null')
                                            ? currentState.toUpperCase()
                                            : null;  // current state name

                                        if (currentState && currentState.toLowerCase() == "final") {
                                            let isAllAnswerSaved = true;
                                            /**
                                             * If user hasn't give any questions answer of group targeting and see the final page then we will mark as PSQT
                                             *
                                             * 1) We will check answer is stored in the localstorageSavedAnswer or not
                                             * 2) If answer is stored in the localstorage then we will check that all question answer is available or not as per the group targetting
                                             * 3) If answer is not stored in the localstorage then we will check the group targetting is available or not.
                                             * 4) If we found any group targetting is not answered then we will mark as PSQT.
                                             */

                                            //check the piiQuesForm and smsQuesForm details are added or not
                                            piiQuesFormDetails = ($that.sharedService.rootData.piiQuesFormDetails && Object.keys($that.sharedService.rootData.piiQuesFormDetails).length)
                                                ? Object.keys($that.sharedService.rootData.piiQuesFormDetails)
                                                : [];

                                            smsQuesFormDetails = ($that.sharedService.rootData.smsQuesFormDetails && Object.keys($that.sharedService.rootData.smsQuesFormDetails).length)
                                                ? Object.keys($that.sharedService.rootData.smsQuesFormDetails)
                                                : [];

                                            let termSurveyAns: any = [];

                                            if ($that.isSavedAnswer) {
                                                // check user has gave all the questions which are in group targeting
                                                let isSavedAnswerKeys = $that.isSavedAnswer.map((queAns: any) => { return Object.keys(queAns) }).flat(1); // fetch question keys
                                                let isPIIquestFilled = $that.isSavedAnswer.find((ans: any) => {
                                                    return ans.piiFormDetails
                                                });
                                                let isSMSquestFilled = $that.isSavedAnswer.find((ans: any) => {
                                                    return ans.smsFormDetails
                                                })

                                                if (isSavedAnswerKeys?.length &&
                                                    $that.sharedService.rootData.questions?.length) {
                                                    if ($that.sharedService.rootData.jb_id == $that.sharedService.rootData.babyCenterProfileSurveyJobId ||
                                                        $that.sharedService.rootData.jb_id == $that.sharedService.rootData.wteProfileSurveyJobId) {

                                                        isSavedAnswerKeys.forEach((key: string) => {
                                                            if ($that.env.innovate.skipQuestionsOn[key]) {
                                                                let svAns = $that.isSavedAnswer.find((ans: any) => {
                                                                    return ans[key] && ans[key].question_type == "Single Punch"
                                                                });
                                                                if (svAns && (!$that.env.innovate.skipQuestionsOn[key].skipOnValue ||
                                                                    $that.env.innovate.skipQuestionsOn[key].skipOnValue == svAns[key].option_text.toLowerCase())) {
                                                                    $that.sharedService.rootData.questions = $that.sharedService.rootData.questions
                                                                        .filter((que: any) => {
                                                                            return !$that.env.innovate.skipQuestionsOn[key].skipKeys.includes(que.questionKey)
                                                                        });
                                                                }
                                                            }
                                                        });
                                                    }

                                                    let questionKeys = $that.sharedService.rootData.questions.map((que: any) => {
                                                        return que.questionKey
                                                    }); // question key of group targetting;

                                                    const isZipcodeAvailable = questionKeys.indexOf("ZIPCODES");
                                                    if (isZipcodeAvailable !== -1) {
                                                        questionKeys.splice(isZipcodeAvailable, 1);
                                                        questionKeys = questionKeys.concat($that.sharedService.rootData.geoQuestionsKeyDetails);
                                                    }

                                                    //if we add ADDRESS_LINE in group targeting then we will remove it from the PII question and then add address detail questions
                                                    let indexOfAddress = questionKeys.indexOf("ADDRESS_LINE");
                                                    if (indexOfAddress > -1) {
                                                        questionKeys.splice(indexOfAddress, 1);
                                                        questionKeys.concat(['street1', 'city', 'state', 'zip']);
                                                    }

                                                    for (let qKey in questionKeys) {
                                                        if (!isSavedAnswerKeys.includes(questionKeys[qKey])) {
                                                            if (((!piiQuesFormDetails?.length
                                                                || !piiQuesFormDetails.includes(questionKeys[qKey])))
                                                                && !isPIIquestFilled
                                                                && !isSMSquestFilled
                                                                && !$that.sharedService.rootData.zipMasterData[questionKeys[qKey]]) {
                                                                isAllAnswerSaved = false;
                                                                break;
                                                            }
                                                        }
                                                        if ($that.sharedService.rootData.surveyFlowLogic) {
                                                            let qky = questionKeys[qKey];
                                                            $that.isSavedAnswer
                                                                .filter((ans: any) => {
                                                                    if (ans[qky]?.terminate) {
                                                                        termSurveyAns.push(ans[qky]);
                                                                    };
                                                                });
                                                        }
                                                    }
                                                }
                                            }
                                            if (!$that.isSavedAnswer && $that.sharedService.rootData.questions?.length) {
                                                isAllAnswerSaved = false;
                                            }

                                            if (!isAllAnswerSaved || termSurveyAns.length) {
                                                let body: any = {};
                                                body.transStatus = environment.innovate.transactionStatus['PSQT']; //termination
                                                body.uid = $that.sharedService.rootData.uid;
                                                body.reason = "URL Manipulation";
                                                body.jobId = $that.sharedService.rootData.jb_id;
                                                body.supCode = $that.sharedService.rootData.supCode;
                                                body.grpId = $that.sharedService.rootData.grp_id;
                                                body.PID = $that.sharedService.rootData.PID;

                                                $that.sharedService.preSurveyTerminationInQA(body)
                                                    .subscribe({
                                                        next(data: any) {
                                                            $that.sharedService.rootData.viewLoading = false;
                                                            $that.router.navigate(['/survey/closed'], { queryParams: { message: 1, ...$that.queryParamsOBJ } });
                                                            if (data.data?.surveyUrl) {
                                                                $that.sharedService.getPersonilzedSurvey($that.sharedService.rootData.uid).subscribe({
                                                                    next(resp: any) {
                                                                        if (resp?.data?.url) {
                                                                            data.data.surveyUrl = resp.data.url;
                                                                        }
                                                                        setTimeout(() => {
                                                                            globalThis.location.href = data.data.surveyUrl;
                                                                        }, 2000);
                                                                    },
                                                                    error(err: any) {
                                                                        setTimeout(() => {
                                                                            globalThis.location.href = data.data.surveyUrl;
                                                                        }, 2000);
                                                                    }
                                                                });
                                                            }
                                                        },
                                                        error(err) {
                                                            $that.router.navigate(['/survey/closed'], { queryParams: $that.queryParamsOBJ });
                                                        }
                                                    });
                                            }
                                            $that.sharedService.rootData.viewLoading = false;
                                        }
                                        else {
                                            const isTerm = $that.sharedService.commonPCCondition();
                                            if (isTerm && $that.sharedService.rootData.originalTerm) {
                                                $that.sharedService.rootData.viewLoading = false;
                                                $that.router.navigate(['/survey/closed'], { queryParams: { message: 1, ...$that.queryParamsOBJ } });
                                                $that.sharedService.getPersonilzedSurvey($that.sharedService.rootData.uid).subscribe({
                                                    next(resp: any) {
                                                        if (resp?.data?.url) {
                                                            $that.sharedService.rootData.originalTermURL = resp.data.url;
                                                        }
                                                        if ($that.sharedService.rootData.originalTermURL) {
                                                            setTimeout(() => {
                                                                globalThis.location.href = $that.sharedService.rootData.originalTermURL
                                                            }, 2000);
                                                        } else {
                                                            $that.sharedService.getSupplierRedirectURL($that.sharedService.rootData.uid)
                                                                .subscribe({
                                                                    next(data: any) {
                                                                        $that.sharedService.rootData.originalTermURL = $that.env.innovate.oldRouteEnable
                                                                            ? data.url
                                                                            : data.data;
                                                                        setTimeout(() => {
                                                                            globalThis.location.href = $that.sharedService.rootData.originalTermURL;
                                                                        }, 2000);
                                                                    },
                                                                    error(err: any) {
                                                                        console.error(`[AppComponent] getSupplierRedirectURL (term) error:${JSON.stringify(err)} ${JSON.stringify($that.sharedService.rootData)}`);
                                                                    }
                                                                });
                                                        }
                                                    },
                                                    error(err: any) {
                                                        console.error(`[AppComponent] getPersonilzedSurvey (term) error = :${JSON.stringify(err)} ${JSON.stringify($that.sharedService.rootData)}`);
                                                    }
                                                });
                                            }
                                            else {
                                                if (!(localStorageSavedAnswers?.length)) {
                                                    $that.sharedService.rootData.viewLoading = false;
                                                    return;
                                                }

                                                let counter = 0;
                                                localStorageSavedAnswers.forEach((data: any) => {
                                                    if (data[$that.sharedService.rootData.keyForSaving]) {
                                                        $that.allStats1 = ($that.sharedService.rootData.questions?.length)
                                                            ? $that.sharedService.rootData.questions.map((que: any) => { return que.questionKey })
                                                            : []; // question key of group targetting;

                                                        (data[$that.sharedService.rootData.keyForSaving]).forEach((savedQuestion: any) => {
                                                            if (savedQuestion[stateName]) {
                                                                if (savedQuestion[stateName].question_type != undefined && savedQuestion[stateName].question_type != 'Multipunch') {
                                                                    //qustion is checked or value shown in form, if user already gone throug from same question
                                                                    $that.sharedService.rootData.demographic.selected_opt = savedQuestion[stateName].answer;
                                                                } else {
                                                                    let selectedOptions: any = {};
                                                                    $that.sharedService.rootData.selectedCheckboxes = 0;
                                                                    savedQuestion[stateName].answer
                                                                        .split(',').forEach((optionId: any) => {
                                                                            let intOpt = Number.parseInt(optionId);
                                                                            selectedOptions[intOpt] = true;
                                                                            $that.sharedService.rootData.selectedCheckboxes++;
                                                                        });
                                                                    $that.sharedService.rootData.multipunch = selectedOptions;
                                                                    $that.sharedService.doMultiPunchCheckbox($that.sharedService.rootData.multipunch);
                                                                }
                                                            }

                                                            let questionKeys = ($that.sharedService.rootData.questions?.length)
                                                                ? $that.sharedService.rootData.questions.map((que: any) => { return que.questionKey })
                                                                : []; // question key of group targetting;

                                                            if (fromState && savedQuestion[fromState] &&
                                                                questionKeys.length &&
                                                                $that.env.innovate.skipQuestionsOn[fromState]) {
                                                                let answer = savedQuestion[fromState];
                                                                if (!$that.env.innovate.skipQuestionsOn[fromState].skipOnValue ||
                                                                    $that.env.innovate.skipQuestionsOn[fromState].skipOnValue ==
                                                                    answer.option_text.toLowerCase()) {
                                                                    $that.sharedService.rootData.questions = $that.sharedService.rootData.questions
                                                                        .filter((que: any) => {
                                                                            return !$that.env.innovate.skipQuestionsOn[fromState].skipKeys.includes(que.questionKey)
                                                                        });

                                                                    $that.allStats1 = ($that.sharedService.rootData.questions?.length)
                                                                        ? $that.sharedService.rootData.questions.map((que: any) => { return que.questionKey })
                                                                        : []; // question key of group targetting;
                                                                }
                                                                if ($that.env.innovate.skipQuestionsOn[fromState].addChildInfo
                                                                    && $that.env.innovate.skipQuestionsOn[fromState].skipOnValue
                                                                    && $that.env.innovate.skipQuestionsOn[fromState].skipOnValue !== answer.option_text.toLowerCase()
                                                                    && !$that.sharedService.rootData.bbCenterChildDetails.length) {
                                                                    let count = Number.parseInt(answer.option_text);
                                                                    $that.sharedService.rootData.bbCenterChildDetails = [];
                                                                    for (let i = 0; i < count; i++) {
                                                                        $that.sharedService.rootData.bbCenterChildDetails.push({
                                                                            'name': 'Child ' + $that.childData[i],
                                                                            'month': '',
                                                                            'year': '',
                                                                            'dob': '',
                                                                            'gender': '',
                                                                            'age': ''
                                                                        });
                                                                    }
                                                                }
                                                            } else {
                                                                for (let svQue in savedQuestion) {
                                                                    if ($that.env.innovate.skipQuestionsOn[svQue] && savedQuestion[svQue] && savedQuestion[svQue].question_type == 'Single Punch') {
                                                                        if (!$that.env.innovate.skipQuestionsOn[svQue].skipOnValue
                                                                            || $that.env.innovate.skipQuestionsOn[svQue].skipOnValue ==
                                                                            savedQuestion[svQue].option_text.toLowerCase()) {

                                                                            $that.sharedService.rootData.questions = $that.sharedService.rootData.questions
                                                                                .filter((que: any) => {
                                                                                    return !$that.env.innovate.skipQuestionsOn[svQue].skipKeys.includes(que.questionKey)
                                                                                });

                                                                            $that.allStats1 = ($that.sharedService.rootData.questions?.length)
                                                                                ? $that.sharedService.rootData.questions.map((que: any) => { return que.questionKey })
                                                                                : []; // question key of group targetting;
                                                                        }

                                                                        if ($that.env.innovate.skipQuestionsOn[svQue].addChildInfo
                                                                            && $that.env.innovate.skipQuestionsOn[svQue].skipOnValue
                                                                            && $that.env.innovate.skipQuestionsOn[svQue].skipOnValue !== savedQuestion[svQue].option_text.toLowerCase()
                                                                            && !$that.sharedService.rootData.bbCenterChildDetails.length) {
                                                                            let count = Number.parseInt(savedQuestion[svQue].option_text);
                                                                            $that.sharedService.rootData.bbCenterChildDetails = [];
                                                                            for (let i = 0; i < count; i++) {
                                                                                $that.sharedService.rootData.bbCenterChildDetails.push({
                                                                                    'name': 'Child ' + $that.childData[i],
                                                                                    'month': '',
                                                                                    'year': '',
                                                                                    'dob': '',
                                                                                    'gender': '',
                                                                                    'age': ''
                                                                                });
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        });
                                                        let savedAnswers = (localStorageSavedAnswers?.length && localStorageSavedAnswers[0][$that.sharedService.rootData.keyForSaving])
                                                            ? localStorageSavedAnswers[0][$that.sharedService.rootData.keyForSaving]
                                                            : [];
                                                        let isSavedAnswerKeys = savedAnswers.map((queAns: any) => { return Object.keys(queAns) }).flat(1); // fetch question keys
                                                        let isPIIOptSaved = false;
                                                        piiQuesFormDetails = ($that.sharedService.rootData.piiQuesFormDetails
                                                            && Object.keys($that.sharedService.rootData.piiQuesFormDetails).length)
                                                            ? Object.keys($that.sharedService.rootData.piiQuesFormDetails)
                                                            : [];

                                                        for (let t_stat in isSavedAnswerKeys) {
                                                            let index = $that.allStats1.indexOf(isSavedAnswerKeys[t_stat]);
                                                            if (index > -1) {
                                                                if (isSavedAnswerKeys[t_stat].toLowerCase() == 'pii_opt') {
                                                                    isPIIOptSaved = true;
                                                                }
                                                                $that.allStats1.splice(index, 1);
                                                            }
                                                        }

                                                        if (piiQuesFormDetails.length) {
                                                            let indexOfAddress = $that.allStats1.indexOf("ADDRESS_LINE");
                                                            if (indexOfAddress > -1) {
                                                                $that.allStats1.splice(indexOfAddress, 1);
                                                                $that.allStats1.concat(['street1', 'city', 'state', 'zip']);
                                                            }
                                                        }

                                                        const piiQuesFormArr = [...piiQuesFormDetails];
                                                        for (let i = 0; i < piiQuesFormArr.length; i++) {
                                                            let index = $that.allStats1.indexOf(piiQuesFormArr[i]);
                                                            if (index > -1) {
                                                                $that.allStats1 = $that.allStats1.filter((key: any) => key !== piiQuesFormArr[i]);
                                                                piiQuesFormDetails = piiQuesFormDetails.filter((qKey: any) => qKey !== piiQuesFormArr[i]);
                                                            }
                                                        };

                                                        if ($that.allStats1?.length) {
                                                            let setQkey = $that.allStats1[0];
                                                            if ($that.sharedService.rootData.piiQuesKey?.includes(setQkey)) {
                                                                setQkey = isPIIOptSaved ? 'pii' : 'pii_opt';
                                                            }
                                                            let nextStat = $that.HTML2TXT.transform((setQkey).toLowerCase());
                                                            $that.router.navigate(['/survey', nextStat], { queryParams: $that.queryParamsOBJ });
                                                        } else {
                                                            const piiQuesKeyExists = !!($that.sharedService.rootData.piiQuesKey?.length);
                                                            const piiQuesFormDetailsExists = $that.sharedService.rootData?.piiFormSubmited ? true : false;

                                                            piiQuesKeyExists
                                                                ? (piiQuesFormDetailsExists
                                                                    ? $that.router.navigate(['/survey/final'], { queryParams: $that.queryParamsOBJ })
                                                                    : $that.router.navigate(['/survey/pii'], { queryParams: $that.queryParamsOBJ }))
                                                                : $that.router.navigate(['/survey/final'], { queryParams: $that.queryParamsOBJ });
                                                        }
                                                    }
                                                    counter++;
                                                    if (counter === localStorageSavedAnswers.length) {
                                                        $that.sharedService.rootData.viewLoading = false;
                                                    }
                                                });
                                            }
                                        }
                                    }
                                } else {
                                    $that.router.navigate(['/survey/closed'], { queryParams: { message: 3, ...$that.queryParamsOBJ } });
                                }
                            }
                        },
                        error(err: any) {
                            console.error(`[AppComponent] getTransaction error access_denied  ${JSON.stringify(err)} ${this.urlPath} ${JSON.stringify($that.sharedService.rootData)}`);
                            $that.router.navigate(['/access_denied']);
                        }
                    });
            } else if (this.sharedService.rootData.Test) {
                if (this.sharedService.rootData.originalTerm &&
                    (this.sharedService.rootData.isPCProfile ||
                        (currentState.toLowerCase() === 'final' &&
                            this.sharedService.rootData.surveyFlowLogic)
                    )) {
                    let query_strings = this.sharedService.serialize($that.queryParamsOBJ);
                    this.sharedService.getSupplierTestUrl(query_strings)
                        .subscribe({
                            next(data: any) {
                                data.data = $that.sharedService.commonDecryptionMethod(data.data);
                                if ($that.env.innovate.triggerNewSupplierURL) {
                                    data = data.data;
                                }
                                $that.router.navigate(['/survey/closed'], { queryParams: $that.queryParamsOBJ });
                                setTimeout(() => {
                                    if (data?.supplierTestUrl)
                                        globalThis.location.href = data.supplierTestUrl;
                                }, 2000);
                            },
                            error(err: any) {
                                console.error(`getSupplierTestUrl error ======> ${JSON.stringify(err)}`);
                                $that.router.navigate(['/survey/closed'], { queryParams: $that.queryParamsOBJ });
                            }
                        });
                } else {
                    this.sharedService.rootData.viewLoading = false;
                    this.sharedService.rootData.demographic = {}; // this is used for sungle punch, numeric and text field in form model
                    this.sharedService.rootData.multipunch = {}; // this is used for multipunch in form model
                    if ($that.isSavedAnswer
                        && fromState === $that.env.innovate.babyCenterChildCountQueKey) {
                        // fetch question keys
                        const isSavedAnswerKeys = $that.isSavedAnswer
                            .map((queAns: any) => Object.keys(queAns)).flat(1);

                        const childCountData = isSavedAnswerKeys.indexOf(fromState);

                        if (childCountData !== -1) {
                            let count = Number.parseInt($that.isSavedAnswer[childCountData][fromState].option_text);
                            this.sharedService.rootData.bbCenterChildDetails = [];
                            for (let i = 0; i < count; i++) {
                                this.sharedService.rootData.bbCenterChildDetails.push({
                                    'name': 'Child ' + $that.childData[i],
                                    'month': '',
                                    'year': '',
                                    'dob': '',
                                    'gender': '',
                                    'age': ''
                                });
                            }
                        }
                    }
                }
            } else {
                this.router.navigate(['/survey/closed'], { queryParams: { message: 4, ...$that.queryParamsOBJ } });
            }
        }
    }
}
